// import React, { useEffect, useState } from "react";
// import {
//   IonCard,
//   IonCardHeader,
//   IonCardTitle,
//   IonCardContent,
//   IonSpinner,
//   IonText,
// } from "@ionic/react";
// import Chart from "react-apexcharts";
// import { useTranslation } from "react-i18next";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchStocks } from "../../redux/actions/canadaNowActions";

// const MarketCard = () => {
//   const { stocks, loading } = useSelector((state) => state.canadaNow);
//   const dispatch = useDispatch();
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const { t } = useTranslation();

//   const stockList = [
//     // Banks
//     { symbol: "RY.TO", name: "Royal Bank of Canada" },
//     { symbol: "TD.TO", name: "Toronto-Dominion Bank" },
//     { symbol: "BNS.TO", name: "Bank of Nova Scotia" },
//     { symbol: "BMO.TO", name: "Bank of Montreal" },
//     { symbol: "CM.TO", name: "CIBC" },
//     { symbol: "NA.TO", name: "National Bank of Canada" },

//     // Energy
//     { symbol: "ENB.TO", name: "Enbridge Inc." },
//     { symbol: "CNQ.TO", name: "Canadian Natural Resources" },
//     { symbol: "SU.TO", name: "Suncor Energy" },

//     // Tech
//     { symbol: "SHOP.TO", name: "Shopify Inc." },
//     { symbol: "GIB-A.TO", name: "CGI Inc." },

//     // Transport
//     { symbol: "CNR.TO", name: "Canadian National Railway" },
//     { symbol: "CP.TO", name: "Canadian Pacific Kansas City" },

//     // Telecom
//     { symbol: "BCE.TO", name: "BCE Inc." },
//     { symbol: "T.TO", name: "Telus" },
//   ];

//   useEffect(() => {
//     if (!stocks) {
//       const symbols = stockList.map((s) => s.symbol).join(",");
//       dispatch(fetchStocks(symbols));
//     }
//   }, [dispatch, stocks]);

//   // Rotate items every 6 seconds
//   useEffect(() => {
//     if (stocks && stocks.length > 1) {
//       const interval = setInterval(() => {
//         setCurrentIndex((prev) => (prev + 1) % stocks.length);
//       }, 6000);
//       return () => clearInterval(interval);
//     }
//   }, [stocks]);

//   if (loading && !stocks) return <IonSpinner />;

//   if (!stocks || stocks.length === 0) {
//     return (
//       <IonCard className="ion-padding">
//         <IonCardHeader>
//           <IonCardTitle>🍁 {t("noMarketDataFound")}</IonCardTitle>
//         </IonCardHeader>
//         <IonCardContent>{t("noMarketDataFoundContent")}</IonCardContent>
//       </IonCard>
//     );
//   }

//   const currentData = stocks[currentIndex];
//   const stockMeta = stockList.find((s) => s.symbol === currentData.symbol) || {
//     name: currentData.symbol,
//   };

//   const current = {
//     ...currentData,
//     name: stockMeta.name,
//     link: `https://ca.finance.yahoo.com/quote/${currentData.symbol}`,
//   };

//   const isPositive =
//     current.change && current.change.startsWith("-") ? false : true;

//   return (
//     <div className="post__side--right post">
//       <IonCardHeader>
//         <IonCardTitle className="local-header">
//           {"📈 " + t("market")}
//           {/* {t("canadianMarket")} */}
//         </IonCardTitle>
//       </IonCardHeader>
//       <IonCard
//         style={{
//           borderRadius: "20px",
//           boxShadow: "0px 6px 16px rgba(0,0,0,0.15)",
//           background: "linear-gradient(135deg, #fff, #fefefc)",
//           borderLeft: "6px solid #d32f2f",
//           margin: "12px",
//         }}
//       >
//         <IonCardHeader>
//           <IonCardTitle style={{ fontSize: "1.2rem", color: "#b71c1c" }}>
//             🍁{" "}
//             <a
//               href={current.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ textDecoration: "none", color: "#b71c1c" }}
//             >
//               {current.name}
//             </a>
//           </IonCardTitle>
//         </IonCardHeader>
//         <IonCardContent style={{ fontSize: "0.95rem", lineHeight: "1.4" }}>
//           {current.price !== null ? (
//             <>
//               💰 ${current.price.toLocaleString()}{" "}
//               <span
//                 style={{
//                   color: isPositive ? "green" : "red",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {isPositive ? "▲" : "▼"} {current.change}
//               </span>
//             </>
//           ) : (
//             <span style={{ color: "#b71c1c", fontWeight: "bold" }}>
//               Data unavailable (API limit or error)
//             </span>
//           )}
//           <br />
//           <span
//             style={{
//               fontSize: "0.8rem",
//               color: "#555",
//               fontStyle: "italic",
//             }}
//           >
//             {/* {current.type === "stock" ? "TSX Stock" : "Crypto"} */}
//             TSX Stock
//           </span>
//           {current.history && current.price !== null && (
//             <Chart
//               type="line"
//               height={80}
//               width="100%"
//               series={[{ data: current.history }]}
//               options={{
//                 chart: {
//                   sparkline: { enabled: true },
//                   animations: { enabled: true },
//                 },
//                 stroke: { curve: "smooth", width: 2 },
//                 colors: [isPositive ? "#2e7d32" : "#c62828"],
//                 tooltip: { enabled: false },
//               }}
//             />
//           )}
//           <IonText>
//             <p>TSX · Canada 🇨🇦</p>
//           </IonText>
//         </IonCardContent>
//       </IonCard>
//     </div>
//   );
// };

// export default MarketCard;

import React, { useEffect } from "react";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonSpinner,
  IonText,
} from "@ionic/react";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchStocks } from "../../redux/actions/canadaNowActions";

const MarketCard = () => {
  const { stocks, loading } = useSelector((state) => state.canadaNow);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const stockList = [
    // Banks
    { symbol: "RY.TO", name: "Royal Bank of Canada" },
    { symbol: "TD.TO", name: "Toronto-Dominion Bank" },
    { symbol: "BNS.TO", name: "Bank of Nova Scotia" },
    { symbol: "BMO.TO", name: "Bank of Montreal" },
    { symbol: "CM.TO", name: "CIBC" },
    { symbol: "NA.TO", name: "National Bank of Canada" },

    // Energy
    { symbol: "ENB.TO", name: "Enbridge Inc." },
    { symbol: "CNQ.TO", name: "Canadian Natural Resources" },
    { symbol: "SU.TO", name: "Suncor Energy" },

    // Tech
    { symbol: "SHOP.TO", name: "Shopify Inc." },
    { symbol: "GIB-A.TO", name: "CGI Inc." },

    // Transport
    { symbol: "CNR.TO", name: "Canadian National Railway" },
    { symbol: "CP.TO", name: "Canadian Pacific Kansas City" },

    // Telecom
    { symbol: "BCE.TO", name: "BCE Inc." },
    { symbol: "T.TO", name: "Telus" },
  ];

  useEffect(() => {
    if (!stocks || stocks.length === 0) {
      const symbols = stockList.map((s) => s.symbol).join(",");
      dispatch(fetchStocks(symbols));
    }
  }, [dispatch, stocks]);

  // If loading and no data exists yet
  if (loading && (!stocks || stocks.length === 0)) {
    return (
      <div className="ion-text-center ion-padding">
        <IonSpinner />
      </div>
    );
  }

  // If fetch finished but no stocks returned
  if (!stocks || stocks.length === 0) {
    return (
      <IonCard className="ion-padding">
        <IonCardHeader>
          <IonCardTitle>🍁 {t("noMarketDataFound")}</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>{t("noMarketDataFoundContent")}</IonCardContent>
      </IonCard>
    );
  }

  return (
    <div className="post__side--right post">
      <IonCardHeader>
        <IonCardTitle className="local-header">
          {"📈 " + t("market")}
        </IonCardTitle>
      </IonCardHeader>

      {/* Added a scrollable container to manage the height of multiple cards */}
      <div
        style={{ maxHeight: "600px", overflowY: "auto", paddingBottom: "10px" }}
      >
        {stocks.map((stockData, index) => {
          // Find the corresponding meta data (name) from the static list
          const stockMeta = stockList.find(
            (s) => s.symbol === stockData.symbol,
          ) || {
            name: stockData.symbol,
          };

          const current = {
            ...stockData,
            name: stockMeta.name,
            link: `https://ca.finance.yahoo.com/quote/${stockData.symbol}`,
          };

          const isPositive =
            current.change && current.change.startsWith("-") ? false : true;

          return (
            <IonCard
              key={current.symbol || index}
              style={{
                borderRadius: "20px",
                boxShadow: "0px 6px 16px rgba(0,0,0,0.15)",
                background: "linear-gradient(135deg, #fff, #fefefc)",
                borderLeft: "6px solid #d32f2f",
                margin: "12px",
              }}
            >
              <IonCardHeader>
                <IonCardTitle style={{ fontSize: "1.2rem", color: "#b71c1c" }}>
                  🍁{" "}
                  <a
                    href={current.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "#b71c1c" }}
                  >
                    {current.name}
                  </a>
                </IonCardTitle>
              </IonCardHeader>
              <IonCardContent
                style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
              >
                {current.price !== null ? (
                  <>
                    💰 ${current.price.toLocaleString()}{" "}
                    <span
                      style={{
                        color: isPositive ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {isPositive ? "▲" : "▼"} {current.change}
                    </span>
                  </>
                ) : (
                  <span style={{ color: "#b71c1c", fontWeight: "bold" }}>
                    Data unavailable (API limit or error)
                  </span>
                )}
                <br />
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#555",
                    fontStyle: "italic",
                  }}
                >
                  TSX Stock
                </span>
                {current.history && current.price !== null && (
                  <Chart
                    type="line"
                    height={80}
                    width="100%"
                    series={[{ data: current.history }]}
                    options={{
                      chart: {
                        sparkline: { enabled: true },
                        animations: { enabled: true },
                      },
                      stroke: { curve: "smooth", width: 2 },
                      colors: [isPositive ? "#2e7d32" : "#c62828"],
                      tooltip: { enabled: false },
                    }}
                  />
                )}
                <IonText>
                  <p>TSX · Canada 🇨🇦</p>
                </IonText>
              </IonCardContent>
            </IonCard>
          );
        })}
      </div>
    </div>
  );
};

export default MarketCard;
